"use client"

import { Button } from "@quantum-wealth/dionysus-ui"

type Props = {
  rd?: string
  fallbackUrl?: string
  label: string
}

export default function RedirectButton({ rd, fallbackUrl = "/", label }: Props) {
  const handleClick = () => {
    try {
      const cleaned = decodeURIComponent(rd || "")
        .trim()
        .replace(/^['"]+|['"]+$/g, "")
      const normalized = cleaned.replace(/^https?:\/(?!\/)/, "https://")

      const isAbsolute = /^https?:\/\//.test(normalized)
      window.location.href = isAbsolute ? normalized : fallbackUrl
    } catch {
      window.location.href = fallbackUrl
    }
  }
  return (
    <Button
      className="mx-auto"
      type="button"
      color="primary-default"
      onClick={() => {
        handleClick()
      }}
      size="xs"
    >
      {label}
    </Button>
  )
}
